import * as React from "react";

import { DebouncedInput } from "@editor/components/common/designSystem/Input";
import TemplatesMenu from "@editor/components/left-bar/sections-pane/TemplatesMenu";
import { useLogAnalytics } from "@editor/hooks/useLogAnalytics";
import { useIntervalOptions } from "@editor/utils/use-interval-options";

import { Search } from "lucide-react";

const SEARCH_PROMPTS = [
  "Product comparison table...",
  "Reviews with stars...",
  "FAQ with dropdowns...",
  "Product grid with images...",
  "Includes add to cart button...",
];

const SectionsPane: React.FC = () => {
  const [searchString, setSearchString] = React.useState("");
  const placeholder = useIntervalOptions({
    options: SEARCH_PROMPTS,
    interval: 5000,
  });
  const logEvent = useLogAnalytics();

  return (
    <div className="flex h-full w-full flex-col items-center gap-3">
      <div className="sticky top-0 w-full bg-white px-3">
        <DebouncedInput
          placeholder={placeholder}
          value={searchString}
          onValueChange={setSearchString}
          name="search-input"
          onBlur={() => {
            if (searchString.length > 0) {
              logEvent("components.search", {
                searchString: searchString,
              });
            }
          }}
          autoComplete="off"
          startEnhancer={<Search className="h-3 w-3" />}
          autoFocus={true}
        />
      </div>

      <div className="min-h-0 w-full flex-1 px-3">
        <div className="no-scrollbar h-full overflow-y-auto">
          <TemplatesMenu searchString={searchString} />
        </div>
      </div>
    </div>
  );
};

export default SectionsPane;
